<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${routePrefix}.create`}" class="btn btn-primary btn-sm" v-b-tooltip.hover="{ animation: false }" :title="$t(`${routePrefix}.create_title`)" v-can:create="permissionPrefix">
            <i class="fa fa-plus"></i>
          </router-link>
          <router-link :to="{ name: `${routePrefix}.categories.index`}" class="btn btn-primary btn-sm" v-b-tooltip.hover="{ animation: false}" :title="$t(`${routePrefix}.categories.title`)" v-can:view="permissionPrefix">
            <i class="fa fa-cogs"></i>
          </router-link>
        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.id }} </td>
            <td> {{ item.status }} </td>
            <td> {{ $t(`${transPrefix}.lists.owner_type.${item.ownerType}`) }} </td>
            <td> {{ item.ownerType == 'SYSTEM' ? "" : item.ownerId }} </td>
            <td> {{ item.ownerType == 'SYSTEM' ? "System" : item.ownerName }} </td>
            <td> {{ item.assigneeName || "" }} </td>
            <td> {{ $t(`${transPrefix}.lists.related_type.${item.relatedToType}`) }} </td>
            <td> {{ item.relatedToId }} </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD hh:mm:ss A")  }} </td>
            <table-item-actions :actions="tableItemActions" :params="{'id':item.id}"/>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import {mapGetters} from "vuex";
  import { TICKETS_LIST as CRUD_ACTION_LIST} from 'actions/tickets';
  import search from "./partials/search";
  const CRUD_CODE="tickets";
  const CRUD_PERMISSION_CODE=`${CRUD_CODE}`;

  export default {
    name: "TicketIndex",
    components:{
      search,
    },
    data(){

      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        tableHeaders:[
          {
            'title':`fields.id`
          },
          {
            'title':`fields.status`
          },
          {
            'title':`fields.owner_type`
          },
          {
            'title':`fields.owner_id`
          },
          {
            'title':`fields.owner_name`
          },
          {
            'title':`fields.assignee_name`
          },
          {
            'title':`fields.related_type`
          },
          {
            'title':`fields.related_id`
          },
          {
            'title':`fields.created_at`
          },
          {
            'title':`fields.actions`
          }
        ],
        tableItemActions:[
          {
            code:'show',
            route_name:`${CRUD_CODE}.show`,
            can:`${CRUD_PERMISSION_CODE}_can_view`,
          },
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
          ...this.getSearchFiltersSensitized
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        })
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
    }
  };
</script>
